// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6419":"77f2b18e74702b04","6633":"2170efe77465d801","7399":"394b67b9551956d3"}[chunkId] + ".css";
};